import { Card, CardContent, CardHeader, Typography, Button, Box } from "@mui/material"
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
import { ArrowRight, AccessTime } from "@mui/icons-material"
import { useTheme } from "@mui/material/styles"
import { NavLink } from "react-router-dom"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
const data = [
  { name: "Jan", active: 10, closed: 5, lost: 2 },
  { name: "Feb", active: 12, closed: 7, lost: 3 },
  { name: "Mar", active: 8, closed: 6, lost: 1 },
]
const textColor = "#0d2561"
const itextColor = "#707070"
export default function DealStatusWidget() {
  const theme = useTheme()

  return (
    <Card>
      
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Deal Status
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Active deals vs closed vs lost on a monthly scale.
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <AccessTime fontSize="small" sx={{ color: textColor }} />
          <Typography variant="body2" fontWeight={500} color={textColor}>
            Average Deal Time: 45 days
          </Typography>
        </Box>

        <Box height={200}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 0, left: 0, bottom: 0 }}>
              <CartesianGrid vertical={false} strokeDasharray="3 3" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip />
              <Bar dataKey="active" fill='#0D2863' radius={4} />
              <Bar dataKey="closed" fill='#007E8F' radius={4} />
              <Bar dataKey="lost" fill='#EF4444' radius={4} />
            </BarChart>
          </ResponsiveContainer>
        </Box>
        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontSize: "0.875rem",
                p: 0,
                minHeight: "auto",
                color: textColor
              }}
            >
              View all Deal Status
            </Button>
          </NavLink>
        </Box>

        
      </CardContent>
    </Card>
  )
}
